<template>
	<div>
		<el-form :inline="true" :model="inputForm" ref="inputForm" :rules="rules">
			<el-form-item label="用户手机号：" prop="phoneNumber" label-width="120px">
				<el-input v-model="inputForm.phoneNumber" placeholder="请输入用户手机号" clearable> </el-input>
			</el-form-item>
			<el-form-item label="选择年月：" prop="date" label-width="100px">
				<el-date-picker v-model="inputForm.date" type="month" placeholder="选择年月" value-format="yyyy-MM">
				</el-date-picker>
			</el-form-item>
			<el-form-item label="类型" prop="type" label-width="70px">
				<el-select filterable placeholder="选择类型" v-model="inputForm.type">
					<el-option v-for="(item, index) in typeList" :key="index" :label="item.name" clearable
						:value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="search">搜索</el-button>
			</el-form-item>
		</el-form>
		<el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%;" border stripe>
			<el-table-column prop="name" align="center" label="名称"></el-table-column>
			<el-table-column prop="totalMoney" align="center" label="总收益"></el-table-column>
			<el-table-column prop="totalNum" align="center" label="商品销量"></el-table-column>
			<el-table-column prop="totalSubsidy" align="center" label="总补贴"></el-table-column>
			<el-table-column prop="icon" align="center" fixed="right" label="操作">
				<template slot-scope="scope">
					<el-button type="primary" plain @click="look(scope.row)">查看详情</el-button>

				</template>
			</el-table-column>
		</el-table>

		<!-- 分页器 -->
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="current"
			:page-size="size" :total="total"></el-pagination>

		<el-dialog :title="nameTitle" :visible.sync="dialogshow" :close-on-click-modal="false"
			:before-close="handleClose">
			
					<div class="" style="display: flex;justify-content: space-between; width: 100%;padding-right: 80px;padding-bottom: 20px;" >
						<div class="">
							
						</div>
						<el-button type="primary" @click="dwon">导出</el-button>
					</div>
					
			
			<div class="" style="padding: 0px 20px 30px;background: #ffffff;">
				<el-table ref="multipleTable" :data="tableDatas" tooltip-effect="dark" style="width: 100%;" border
					stripe>
						<el-table-column prop="name" align="center" label="名称"></el-table-column>
						<el-table-column prop="roleName" align="center" label="角色昵称"></el-table-column>
				
					<el-table-column prop="money" align="center" label="差额"></el-table-column>
					<el-table-column prop="revenue" align="center" label="收益"></el-table-column>
				
					<el-table-column prop="myNum" align="center" label="我的数量"></el-table-column>
					<el-table-column prop="sonNum" align="center" label="用户数量"></el-table-column>

				</el-table>
				<el-pagination @size-change="handleSizeChanges" @current-change="handleCurrentChanges"
					layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100]" :current-page="currents"
					:page-size="sizes" :total="totals"></el-pagination>
			</div>

		</el-dialog>
	</div>
</template>

<script>
	import axios from 'axios'
		import ty from '../../utils/ty'
	export default {
		data() {
			return {
				current: 1,
				currents: 1,
				size: 10,
				sizes: 10,
				total: 0,
				totals: 0,
				nameTitle: '',
				dialogshow: false,
				inputForm: {
					phoneNumber: '',
					date: '',
					type: ''
				},
				typeList: [{
						id: 0,
						name: '按门店'
					},
					{
						id: 1,
						name: '按商品'
					}
				],
				tableData: [],
				tableDatas: [],
				rules: {
					phoneNumber: [{
						required: true,
						message: '请输入手机号',
						trigger: 'blur'
					}, ],
					date: [{
						required: true,
						message: '请选择年月',
						trigger: 'change'
					}],
					type: [{
						required: true,
						message: '请选择类型',
						trigger: 'change'
					}]
				},
				itemInfo:'',
				showTime:false
			}
		},
		created() {},
		methods: {
			dwon(){
				var that =this
				if(that.showTime ==false){
					that.showTime =true
					axios({
						method:'post',
						url: ty.apiurl + '/admin/earn/exportcinfo',
						headers: {
							'Content-Type': 'application/json; charset=utf-8',
							'Authorization': localStorage.getItem('token')
						},
						data:{
							id:this.itemInfo.id,
							phone: this.itemInfo.phone,
							month: this.itemInfo.month,
							type: this.itemInfo.type,
						},
						
						responseType: 'blob'
					}).then((res) => {
						console.log('7474', res.data)
						const link = document.createElement('a')
						let blob = new Blob([res.data], {
							type: 'application/vnd.ms-excel'
						})
						link.style.display = 'none'
						link.href = URL.createObjectURL(blob);
						link.setAttribute('download', '查询列表.xlsx');
						link.click();
						link = null;
						
						that.showTime = false
						
					}).catch(error => {
						that.showTime = false
					})
				}
				
			},
			look(e) {
				this.itemInfo =e
				this.nameTitle = e.name
				this.$axios.post('/admin/earn/getGoodsStoreInfo', {
					id: e.id,
					phone: e.phone,
					month: e.month,
					type: e.type,
					pageNo: this.currents,
					pageSize: this.sizes
				}).then((res) => {
					console.log(res);
					if (res.code == 0) {
						this.tableDatas = res.data.records
						this.sizes = res.data.size
						this.currents = res.data.current
						this.totals = res.data.total
						this.dialogshow = true
					}
				})

			},
			search() {
				this.$refs['inputForm'].validate((valid) => {
					if (valid) {
						console.log(this.inputForm.date);
						let obj = {}
						obj.month = this.inputForm.date
						obj.phone = this.inputForm.phoneNumber
						obj.pageNo = this.current
						obj.pageSize = this.size
						obj.type = this.inputForm.type
						this.$axios.post('/admin/earn/getMoneyInfo', obj).then((res) => {
							console.log(res);
							if (res.code == 0) {
								this.tableData = res.data.records
								this.size = res.data.size
								this.current = res.data.current
								this.total = res.data.total
							}
						})
					}
				})
			},
			handleSizeChange(val) {
				console.log('size changed', val);
				this.size = val
				this.search()
			},
			handleCurrentChange(val) {
				console.log('current changed', val);
				this.current = val
				this.search()
			},
			handleSizeChanges(val) {
				console.log('size changed', val);
				this.sizes = val
				this.look(this.itemInfo)
			},
			handleCurrentChanges(val) {
				console.log('current changed', val);
				this.currents = val
				this.look(this.itemInfo)
			},
		},
	}
</script>

<style scoped></style>